import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { ModelBase, ReusableString  } from "@models";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import StringBox from "@components/input/strings/StringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function ReusableStringEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<ReusableString>(param_obj instanceof ReusableString ? param_obj : api.applyWorkingOn(new ReusableString()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);

  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof ReusableString) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Label"
            value={obj.label}
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.label = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <StringBoxWithReusables
            name="Content"
            value={obj.content}
            disabled={disabled}
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.content = changed;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid> */}
      </Grid>
    </ModelBaseInput>
  ); 
}